export default "__VITE_ASSET__De$A3Shj__"